import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { ContentTable } from "./ContentTable";
import { BtnThemMoi } from "components/QuanLyNhanVien/QuanLyCongViec/ThemmoiSuaGiahanGiaoviec/BtnThemMoi";

export const TableDanhSach = ({ phanQuyen, listDanhSach, isLoading, dataSearch, setDataSearch, onSearch, onReload }) => {
    
    const handlePageChange = (pageNumber) => {
        const newSearchData = { ...dataSearch, pageIndex: pageNumber };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };

    const handlePageSizeChange = (pageSize) => {
        const newSearchData = { ...dataSearch, pageSize, pageIndex: 1 };
        setDataSearch(newSearchData);
        onSearch(newSearchData);
    };

    return (
        <>
            {isLoading ? (
                <div className="loading-page1"><div className="loader loader-default is-active"></div></div>
            ) : (
                <>
                    <div className="card border-light mb-2 card-v2">
                        <div className="card-body card-body-v2">
                            <div className="row col-sm-12 col-md-12 themoi-taisanthly mb-1">
                                {phanQuyen.quanlycongviec_themcongviec && <BtnThemMoi onReload={onReload} />}
                            </div>
                            <div className="Left808x200 Table-main-new css-table-ds">
                                <div className="table-mobile table-mobile-hover">
                                    <div className="custom-table-wrapper" style={{ overflowX: "auto", width: '100%' }}>
                                        <div className="table-headers" style={{alignItems: 'stretch'}}>
                                            <div className="custom-table-header text-center flex-basis-5 flex-basis-5-sm">
                                                <p className="color-do-bold">STT <br />[{listDanhSach.iTotal}]</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-12 flex-basis-12-sm">
                                                <p>Mã công việc</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-13 flex-basis-13-sm">
                                                <p>Nhân viên</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Tên công việc</p>
                                            </div>
                                            <div className="custom-table-header text-left flex-basis-15 flex-basis-15-sm">
                                                <p>Liên quan đến hợp đồng</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Thời hạn</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Trạng thái</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Đánh giá</p>
                                            </div>
                                            <div className="custom-table-header text-center flex-basis-10 flex-basis-10-sm">
                                                <p>Chức năng</p>
                                            </div>
                                        </div>
                                        <div className="custom-table-body">
                                            <ContentTable 
                                                listDanhSach={listDanhSach.List}
                                                phanQuyen={phanQuyen}
                                                onReload={onReload}
                                                dataSearch={dataSearch}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {listDanhSach.iTotal > 0 && (
                        <div className="card border-light mb-2 card-v2">
                            <div className="card-body card-body-v2">
                                <PhanTrang
                                    pageIndex={dataSearch.pageIndex}
                                    pageSize={dataSearch.pageSize}
                                    totalCount={listDanhSach.iTotal}
                                    onPageChange={handlePageChange}
                                    onPageSizeChange={handlePageSizeChange}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}
        </>
    );
};